import * as React from 'react';

function ProgressBar() {
    return (
        <div className={`progress automationprog`}>
            <div className={`progress-value automationprog-value`}></div>
          </div>
    );
}

export default ProgressBar;